import React, { Component } from 'react';
import { Table, Button } from 'semantic-ui-react';



class RenderItems extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    remove = () => {
        this.props.removeItem(this.props.item);
    }

    render() {


        return (<div>
            <h3> {this.props.item.itemCode} - {new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'UGX' }).format(this.props.item.amount)}
                <Button color='red' onClick={this.remove}>REMOVE</Button></h3>

            {/* <Table.Row>
                <Table.Cell>{this.props.item.itemCode}</Table.Cell>
                <Table.Cell>{new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'UGX' }).format(this.props.item.amount)}</Table.Cell>
                <Table.Cell><Button color='red' onClick={this.remove}>REMOVE</Button></Table.Cell>
            </Table.Row> */}
        </div>);
    }
}

export default RenderItems;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Billing/RenderItems.js